var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-book","titulo":"CONTRATAÇÕES SGF","subTitulo":"APOIO"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Apoios_Contratacoes' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }